import { render } from "./NoteSidebarSubname.vue?vue&type=template&id=1d05505a&scoped=true"
import script from "./NoteSidebarSubname.vue?vue&type=script&lang=js"
export * from "./NoteSidebarSubname.vue?vue&type=script&lang=js"

import "./NoteSidebarSubname.vue?vue&type=style&index=0&id=1d05505a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d05505a"]])

export default __exports__